import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { profile } from '../data/profile';
import { SectionLink } from './SectionLink';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="w-full bg-navy-900 text-white" data-id="element-60" data-mp="4lyuukqi8cd4">
      <div className="mx-auto grid max-w-shell grid-cols-1 gap-14 px-6 pb-20 pt-16 lg:grid-cols-12 lg:gap-16 lg:px-10 lg:pb-24 lg:pt-24" data-id="element-61" data-mp="4jm4bj6oktog">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="lg:col-span-5" data-id="element-62" data-mp="x9upzl0fdw7s">
          <figure className="relative w-full max-w-[22rem]" data-id="element-63" data-mp="ncgiwc0e6js5">
            <span className="absolute -bottom-3 -right-3 h-full w-full border border-gold-500" aria-hidden="true" data-id="element-64" data-mp="neawf59c39m7" />
            <img src={profile.portrait} alt={`Portrait of ${profile.name}`} className="relative w-full border border-white/15 object-cover" width={352} height={352} data-id="element-65" data-mp="3825wklpczzj9" />
          </figure>

          <h1 className="mt-10 font-display text-4xl font-semibold leading-[1.05] tracking-tightest sm:text-5xl" data-id="element-66" data-mp="39acx8ne15ksh">
            {profile.name}
          </h1>
          <p className="mt-5 font-display text-2xl leading-snug text-gold-200" data-id="element-67" data-mp="3e7uydrlt2vpx">
            {profile.headline}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease,
        delay: 0.08
      }} className="lg:col-span-7 lg:pt-6" data-id="element-68" data-mp="358hlsq2dxr0z">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-gold-500" data-id="element-69" data-mp="2vi53l4i1m9y0">
            {profile.tagline}
          </p>

          <p className="mt-8 max-w-2xl text-xl font-medium leading-relaxed text-white sm:text-2xl" data-id="element-70" data-mp="2hjox9eo3elge">
            {profile.overview}
          </p>

          <div className="mt-10 border-t border-white/15 pt-8" data-id="element-71" data-mp="s1rr4kwyw0sp">
            <p className="text-xs uppercase tracking-[0.12em] text-white/45" data-id="element-72" data-mp="s3coeiao1xu9">
              Primary focus
            </p>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-white/75" data-id="element-73" data-mp="ic873bxiq0w9">
              {profile.primaryFocus}
            </p>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-74" data-mp="dege0el508qh">
            <SectionLink id="impact" className="group inline-flex items-center gap-2 whitespace-nowrap bg-gold-500 px-6 py-3.5 text-sm font-semibold text-navy-950 transition-colors duration-150 ease-exec hover:bg-gold-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-200 focus-visible:ring-offset-2 focus-visible:ring-offset-navy-900" data-id="element-75" data-mp="1b1fel0eya0tn">
              View Executive Impact
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-exec group-hover:translate-x-0.5" aria-hidden="true" data-id="element-76" data-mp="3lui9cqv5izld" />
            </SectionLink>
            <SectionLink id="board" className="inline-flex items-center whitespace-nowrap border border-white/35 px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-150 ease-exec hover:border-white hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-200 focus-visible:ring-offset-2 focus-visible:ring-offset-navy-900" data-id="element-77" data-mp="1x783xkq1jlsj">
              Board &amp; Advisory Profile
            </SectionLink>
          </div>

          <ul className="mt-10 flex flex-col gap-3 text-sm text-white/65 sm:flex-row sm:flex-wrap sm:items-center sm:gap-7" data-id="element-78" data-mp="2l0zzwnwxu1wo">
            <li className="flex items-center gap-2" data-id="element-79" data-mp="2tzbpqnpzcvo2">
              <MapPinIcon className="h-4 w-4 flex-none text-gold-500" aria-hidden="true" data-id="element-80" data-mp="2tz1zcz10wmhu" />
              {profile.location}
            </li>
            <li className="flex items-center gap-2" data-id="element-81" data-mp="zlkfpn3qo9s3">
              <PhoneIcon className="h-4 w-4 flex-none text-gold-500" aria-hidden="true" data-id="element-82" data-mp="zm2mverxw8es" />
              <a href={profile.phoneHref} className="transition-colors duration-150 ease-exec hover:text-white" data-id="element-83" data-mp="4a2t1g0r31xi">
                {profile.phone}
              </a>
            </li>
            <li className="flex items-center gap-2" data-id="element-84" data-mp="e9trttwcg33e">
              <MailIcon className="h-4 w-4 flex-none text-gold-500" aria-hidden="true" data-id="element-85" data-mp="e7h7ja345gn6" />
              <a href={`mailto:${profile.email}`} className="transition-colors duration-150 ease-exec hover:text-white" data-id="element-86" data-mp="9b8rluh3djey">
                {profile.email}
              </a>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}